import { handleActions, combineActions } from "redux-actions";
import * as Immutable from "immutable";

import * as Actions from "./rateActions";
import {userLogoutReceived} from "../../../security";

const initialState: Immutable.Map<string, any> = Immutable.fromJS({
  isFetchingData: false,
  error: '',
  rates: [],
});

//is action payload immutable?
export const rateReducer = handleActions(
  {
    [combineActions(Actions.configureRateRequested, Actions.fetchRatesRequested, Actions.deleteRateRequested, Actions.editRateRequested)](state, action) {
      return state
        .set("isFetchingData", true)
        .set("error", '')
    },
    [combineActions(Actions.fetchRatesFailed, Actions.deleteRateFailed, Actions.editRateFailed, Actions.configureRateFailed)](state, action) {
      return state
        .set("isFetchingData", false)
        .set("error", action.payload)
    },
    [combineActions(Actions.configureRateReceived, Actions.deleteRateReceived, Actions.editRateReceived)](state, action) {
      return state
        .set("isFetchingData", false)
        .set("error", '')
    },
    [Actions.fetchRatesReceived](state, action) {
      return state
        .set("isFetchingData", false)
        .set("rates", Immutable.fromJS(action.payload))
        .set("error", '')
    },
    [Actions.unSetRateError](state, action) {
      return state
        .set("error", '')
    },
    [userLogoutReceived](state, action) {
      return initialState
    }
  },
  initialState
);


// WEBPACK FOOTER //
// ./src/features/rate/store/rateReducer.js